<template>
    <BasicOrdersTableWidget
        :items="dashboardStore.ordersProcesses"
        :loading="dashboardStore.ordersProcessesLoading"
        :widget="widget"
    />
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { useDashboardStore } from '@/stores'
import type { DashboardPermission, DashboardWidget } from '@/stores/dashboard'

import BasicOrdersTableWidget from './BasicOrdersTableWidget.vue'

// 2. Props / Emits
withDefaults(
    defineProps<{
        widget: DashboardWidget
        permissions?: DashboardPermission[]
    }>(),
    { permissions: () => [] }
)

// 4. Stores & top-level services
const dashboardStore = useDashboardStore()
</script>
